<template>
    <div class="b_head_banner">
        <div
            v-full-background-image-path:assets="imageName"
            class="banner_image"
        />
        <div class="banner_wrapper flex small_banner">
            <div class="banner_wrapper_inner">
                <div class="container">
                    <div class="banner_title second_font text_center">
                        {{ title }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        imageName: {
            type: String,
            required: false,
            default: 'head_banner_decor.svg'
        }
    }
};
</script>
